module.exports = __webpack_public_path__ + "static/img/qr-code1.7300593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-code1.png
// module id = RrsB
// module chunks = 7